module.exports = __webpack_public_path__ + "static/media/logo-engie-fabricom-white.fbc464f5.svg";